import { DomainSearchSuiteModule, SearchRecommendationModule } from '@wix/domains-search-suite';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import React from 'react';
import { SearchGateHomeContent } from '../../SearchGateHome';
import { ViewMode } from '../../../types';
import { ExperimentSpecs } from '../../../constants';
import { DeclaredExperimentsProvider } from '../../../hooks/declaredExperiments';
import { usePerceptionEnabled, usePerceptionPricing } from '../../../pricingPerception';
export const FunnelGateHomePage = _ref => {
  var _getPremiumEssentials;
  let {
    handlers,
    externalViewer
  } = _ref;
  const siteName = (_getPremiumEssentials = getPremiumEssentialsSafe()) == null ? void 0 : _getPremiumEssentials.siteName;
  const titleKey = siteName ? undefined : 'domain_search_gate.domain_gate.account_level.page.title';
  const {
    Layouts: perceptionLayouts
  } = usePerceptionPricing('businessManagerGate');
  // Declared at the page, so it covers every priced section inside it.
  const experimentIds = usePerceptionEnabled() ? [ExperimentSpecs.PricingPerceptionFirstYear] : [];
  return /*#__PURE__*/React.createElement(DeclaredExperimentsProvider, {
    ids: experimentIds
  }, /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      enabledActions: ['alreadyAssignedToThisSite', 'alreadyAssigned', 'floatingDomain'],
      handlers,
      siteInfo: {
        externalViewer: Boolean(externalViewer)
      },
      uiConfig: {
        fullPage: true
      }
    }
  }, /*#__PURE__*/React.createElement(SearchRecommendationModule.Provider, {
    Layouts: {
      customConfiguration: perceptionLayouts ?? {}
    }
  }, /*#__PURE__*/React.createElement(SearchGateHomeContent, {
    hideBackButton: true,
    viewMode: ViewMode.FUNNEL_GATE,
    titleKey: titleKey,
    perception: Boolean(perceptionLayouts)
  }))));
};
//# sourceMappingURL=FunnelGateHomePage.js.map